import $ from 'jquery';

export default function initHeader() {
    $(function () {
        $(".menu-icon").on("click", (e) => {
            $(".menu-icon").toggleClass('active');
            $(".logo-wrapper").toggleClass('active');
            $("nav").toggleClass('active');
        })
    })
};
